import React, { Component } from 'react';
import MainPicSlickWrap from './MainPicSlickWrap';

export default class MainSlickShowWrap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      excludeCategoryList: [],
      excludeItemList: [],
    }
  }
  
  updateFilterState() {
    let excludeCategoryList = [];
    let excludeItemList = [];

    const {
      // isGoToTheSamePosition,
      // isReset,
      planningData,
      selectedCategoryIndex,
    } = this.props;
    const {
      selectedState
    } = this.props;

    // 選到的分類
    let SelectedCategory = planningData.category[selectedCategoryIndex];

    SelectedCategory.categoryList.forEach((cateItem, cateIndex) => {
      if (selectedState[cateIndex] !== undefined) {
        // console.log(cateItem);
        // console.log(selectedState[cateIndex]);
        excludeCategoryList.push(cateItem.itemList[selectedState[cateIndex].showIndex].excludeCategoryList)
        excludeItemList.push(cateItem.itemList[selectedState[cateIndex].showIndex].excludeItemList)
      }
    });
    // console.log('excludeCategoryList', excludeCategoryList);
    // console.log('excludeItemList', excludeItemList);

    this.setState({
      excludeCategoryList: excludeCategoryList,
      excludeItemList: excludeItemList,
    })

  }

  componentDidUpdate(prevProps) {
    // // 預計把例外處理放在這邊
    if (JSON.stringify(this.props.selectedState) !== JSON.stringify(prevProps.selectedState)) {
      this.updateFilterState();
    }
  }
  render() {
    const {
      planningData,
      isShowResult,
      CategoryData,
      isReset,
      selectedCategoryIndex,
      SelectedCategoryFacets,
      setSlideArray,
      selectedState,
      gotoRow,
      isGoToTheSamePosition,
      updateSamePosition,
    } = this.props;

    const {
      excludeCategoryList,
      excludeItemList
    } = this.state;

    return (
      <div className="imgWrap my-3 py-3">
        {
          // console.log(CategoryData)
          CategoryData.categoryList.map((item, index) => {
            return (
              <div
                key={`${CategoryData.categoryTypeName}_${index}`}
                className={`slideWrap ${CategoryData.categoryType}_${index}`}>
                <span className="d-none">
                  {
                    `${CategoryData.categoryType}_${index}`
                  }
                </span>
                {
                  !(JSON.stringify(excludeCategoryList).indexOf(item.itemType) === -1) ? null :
                    <MainPicSlickWrap
                      className={`${CategoryData.categoryType}_${index}`}
                      key={`${item.itemType}`}
                      picItem={item}
                      picIndex={index}
                      isShowResult={isShowResult}
                      planningData={planningData}
                      isReset={isReset}
                      excludeItemList={excludeItemList}
                      selectedCategoryIndex={selectedCategoryIndex}
                      setSlideArray={setSlideArray}
                      selectedState={selectedState}
                      SelectedCategoryFacets={SelectedCategoryFacets}
                      gotoRow={gotoRow}
                      isGoToTheSamePosition={isGoToTheSamePosition}
                      updateSamePosition={updateSamePosition}
                    />
                }
              </div>
            )
          })
        }
      </div>
    )
  }
}
